import axios from 'axios';

// 1. Define Constants and Helpers FIRST
const BASE = 'https://agro.atrmart.in/api';

export const getToken  = () => localStorage.getItem('seller_token');
export const setToken  = (t) => localStorage.setItem('seller_token', t);
export const clearAuth = () => {
  localStorage.removeItem('seller_token');
  localStorage.removeItem('seller_user');
};

// 2. Define the core logic function SECOND
const SellerApi = async (endpoint, options = {}) => {
  const token = getToken();
  const headers = {
    'Accept': 'application/json',
    ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const res = await fetch(`${BASE}${endpoint}`, { ...options, headers });

  if (res.status === 401) { 
    clearAuth(); 
    window.location.href = '/seller'; 
    return; 
  }

  const json = await res.json().catch(() => ({ status: false, message: 'Server error' }));

  if (!res.ok) throw new Error(json.message || `Error ${res.status}`);
  return json;
};

// 3. Define the API objects LAST (Now they can safely access BASE and SellerApi)
// ── AUTH ──────────────────────────────────────────
export const authAPI = {
  sendOtp:   (mobile) => SellerApi('/seller/auth/send-otp',   { method: 'POST', body: JSON.stringify({ mobile }) }),
  verifyOtp: (mobile, otp) => SellerApi('/seller/auth/verify-otp', { method: 'POST', body: JSON.stringify({ mobile, otp }) }),
  register:  (data)  => SellerApi('/seller/auth/register',    { method: 'POST', body: JSON.stringify(data) }),
  me:        ()      => SellerApi('/seller/auth/me'),
  logout:    ()      => SellerApi('/seller/auth/logout',      { method: 'POST' }).finally(clearAuth),
};
// ── DASHBOARD ─────────────────────────────────────
export const dashAPI = {
  getStats:        () => SellerApi('/seller/dashboard/stats'),
  getRecentOrders: () => SellerApi('/seller/dashboard/recent-orders'),
  getEarningsChart:() => SellerApi('/seller/dashboard/earnings-chart'),
};

// ── PRODUCTS ──────────────────────────────────────
export const productAPI = {
  list:   () => SellerApi('/seller/products'),
  add:    (fd) => SellerApi('/seller/products',         { method: 'POST', body: fd }),        // FormData
  update: (id, fd) => SellerApi(`/seller/products/${id}`, { method: 'POST', body: fd }),     // FormData + _method=PUT
  delete: (id) => SellerApi(`/seller/products/${id}`,   { method: 'DELETE' }),
  updatePrice: (id, data) => SellerApi(`/seller/products/${id}/price`, { method: 'PATCH', body: JSON.stringify(data) }),
};

// ── ORDERS ────────────────────────────────────────
export const orderAPI = {
  list: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return SellerApi(`/seller/orders?${q}`);
  },
  // ACCEPTS PENDING ORDERS AND TRANSITIONS THEM TO THE ORDERS GRID VIEW
  accept: (id) => SellerApi(`/seller/orders/${id}/accept`, { method: 'POST' }),
  updateStatus: (id, status) => SellerApi(`/seller/orders/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) }),
  detail: (id) => SellerApi(`/seller/orders/${id}`),
};

// ── RETURNS ───────────────────────────────────────
export const returnAPI = {
  list:   () => SellerApi('/seller/returns'),
  action: (id, action) => SellerApi(`/seller/returns/${id}`, { method: 'PATCH', body: JSON.stringify({ action }) }),
};

// ── WALLET / EARNINGS ─────────────────────────────
export const walletAPI = {
  balance:      () => SellerApi('/seller/wallet/balance'),
  transactions: () => SellerApi('/seller/wallet/transactions'),
  withdraw:     (amount) => SellerApi('/seller/wallet/withdraw', { method: 'POST', body: JSON.stringify({ amount }) }),
  bankDetails:  () => SellerApi('/seller/wallet/bank'),
  saveBank:     (data) => SellerApi('/seller/wallet/bank', { method: 'POST', body: JSON.stringify(data) }),
};

// ── DEALS ─────────────────────────────────────────
export const dealAPI = {
  list:   () => SellerApi('/seller/deals'),
  // FIXED: Removed the break in JSON.stringify
  create: (data) => SellerApi('/seller/deals', { 
    method: 'POST', 
    body: JSON.stringify(data) 
  }),
  delete: (id)   => SellerApi(`/seller/deals/${id}`, { method: 'DELETE' }),
};

// ── PROFILE / ADDRESS ─────────────────────────────
export const profileAPI = {
  get:    () => SellerApi('/seller/profile'),
  update: (data) => SellerApi('/seller/profile', { method: 'PUT', body: JSON.stringify(data) }),
  updateAddress: (data) => SellerApi('/seller/profile/address', { method: 'PUT', body: JSON.stringify(data) }),
  agreePolicies:() => SellerApi('/seller/profile/agree-policies', { method: 'POST' }),
};

// ── NOTIFICATIONS ─────────────────────────────────
export const notifAPI = {
  list:        () => SellerApi('/seller/notifications'),
  markAllRead: () => SellerApi('/seller/notifications/read-all', { method: 'POST' }),
};

// ── FCM PUSH TOKEN ─────────────────────────────────
export const fcmAPI = {
  saveToken: (fcm_token) => SellerApi('/seller/fcm-token', { method: 'POST', body: JSON.stringify({ fcm_token }) }),
};



export default SellerApi;